





































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import { ClientsidePaymentMethod, ClientsidePaymentMethodType } from '@/models/payment/PaymentMethods'

@Component
export default class PaymentMethodRow extends Vue
{
    @Prop(Boolean) readonly project! : Boolean; // default false
    @Prop(String) readonly pid! : String;
    @Prop(Boolean) readonly doesNotOwnSubscription! : Boolean; // default false
    @Prop(String) readonly planId! : String;
    @Prop(ClientsidePaymentMethod) readonly method!: ClientsidePaymentMethod;

    // Done this way rather than $emit('refresh') bc makeMethodActive and removeMethod
    // trigger loading, which destroys the current DOM element and removes the event
    // listeners.
    @Prop(Function) readonly refreshMethod!: Function;

    modalsInitialized = false

    openModal(modal : string)
    {
        this.modalsInitialized = true;
        this.$nextTick(()=>{
            (this.$refs[modal] as any).show();
        })
    }

    async makeMethodActive()
    {
        this.$emit('loading', true)
        try
        {
            if (this.doesNotOwnSubscription)
            {
                const res = await this.$http.post('payments/subscription',
                    {
                        token: this.method.token, 
                        planID: this.planId,
                        id: (this.project) ? this.pid : null,
                        tryCancelFirst: true
                    });
            }
            else
            {
                const res = await this.$http.put('payments/subscription/method',
                    {
                        token: this.method.token, 
                        id: (this.project) ? this.pid : null 
                    });
            }
        }
        catch (er)
        {
            // TODO
            console.error(er);
            alert('Failed to set payment method for this subscription. Make sure all information is correct.');
        }
        
        if (this.refreshMethod)
        {
            this.refreshMethod();
        }
    }

    async removeMethod()
    {
        // TODO
        this.$emit('loading', true)
        try
        {
            let res = await this.$http.delete('payments/customer/method', {data: { token: this.method.token }})
        }
        catch(er)
        {
            // TODO
            console.error(er);
            alert('Failed to delete payment method.');
        }
        
        if (this.refreshMethod)
        {
            this.refreshMethod();
        }
    }

    get CardClassString()
    {
        let type = this.method.cardType.toLowerCase();
        switch(type)
        {
        case "visa":
            return 'fab fa-cc-visa';
        case "american express":
            return 'fab fa-cc-amex';
        case "mastercard":
            return 'fab fa-cc-mastercard';
        case "discover":
            return 'fab fa-cc-discover';
        case "maestro":
            return 'fab fa-cc-maestro';
        case "jcb":
            return 'fab fa-cc-jcb';
        }
        return "fas fa-credit-card"
    }
}
